import { useState } from "react";
import * as constants from "../constants/CONSTANT";
import { render } from "react-dom";
import { redirect } from "react-router-dom";
import { getAxios, getRefreshToken } from "../utils/helper";
const authApi = {
  async login(email, password) {
    let response = await fetch(constants.API_BASE_URL + "/api/auth/login", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    });
    console.log("response",response);
    const result = await response.json();
    console.log("result",result);
    if (result?.success) {
      localStorage.setItem("token", result?.token?.accessToken);
      localStorage.setItem("refreshToken", result?.token?.refreshToken);
    }
    return result;
  },

  // 31 May
  async fetchMyImage() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/auth/myimage", {
      method: "GET",
      //mode: "cors",

      headers: {
        Authorization: token,
      },
    });
    if (response.status === 200) {
      const fileBody = await response.blob();
      return fileBody;
    } else {
      return null;
    }
  },

  async logout() {
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/auth/logout`,
      );

      // If records found
      if (response?.data) {
        if (response?.data?.success) {
          console.log('logout')
          localStorage.clear();
          window.location.href = '/login';
        }
      }

      return response?.data;

    } catch (error) {
      // If some error occurred while calling api request
      console.log('Error in Login', error);
      if (error?.response?.status === 401) {
        console.log('logout')
        localStorage.clear();
        window.location.href = '/login';
      }
      if (error?.response?.status === 403) {
        console.log('logout')
        localStorage.clear();
        window.location.href = '/login';
      }
      return { errors: error?.response?.data?.errors };
    }

  },

  async refreshToken() {
    const instance = getAxios();
    const token = getRefreshToken();
    if (!token) await authApi.logout();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/auth/refresh`,
        {
          token
        }
      );

      // If records found
      if (response?.data) {
        if (response?.data?.success) {
          localStorage.setItem("token", response?.data?.token.accessToken);
          window.location.href = window?.location?.pathname || '/';
        }
      }

      return response?.data;

    } catch (error) {
      // If some error occurred while calling api request
      console.log('Error in Login', error.response.data);
      if (error?.response?.status === 401) {
        await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
  },

  // logout() {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("permissions");
  //   localStorage.clear();
  //   window.location.href = "/login";
  //   // console.log('logout');
  //   // alert("logout");
  // },
  // logout() {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("permissions");
  //   console.log('logout')
  //   // localStorage.clear();
  //   // redirect('/login');
  //   window.location.href='/login';
  // },

  // ---------------------.
  async updateUserById(record) {
    const id = record.id;
    delete record.id;
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.put(
        `${constants.API_BASE_URL}/api/auth/users/${id}`,
        { ...record }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },

  async fetchUserRoles() {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/auth/user-roles`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async updateUserRoleById(record) {
    // Get axios instance
    const instance = getAxios();
    try {
      const id = record.id;
      delete record.id;
      // Call the API
      const response = await instance.put(
        `${constants.API_BASE_URL}/api/auth/user-roles/${id}`,
        { ...record }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }

      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async fetchRoles() {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/auth/roles`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async createRole(record) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/auth/roles`,
        { ...record }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async deleteRoleById(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.delete(
        `${constants.API_BASE_URL}/api/auth/roles/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    }
    catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async fetchPermissions() {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/auth/permissions`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async fetchRolePermissions() {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/auth/role-permissions`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async createPermission(record) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/auth/permissions`,
        { ...record }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout(); 
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async deletePermissionById(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.delete(
        `${constants.API_BASE_URL}/api/auth/permissions/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }
      if (response?.data) {
        return response?.data;
      }
    }
    catch (error) {
      console.error("Error", error.response);
      return error?.response?.data;
    }
    return null;
  },
  async updateRoleById(record) {
    // Get axios instance
    const instance = getAxios();
    try {
      const id = record.id;
      delete record.id;
      // Call the API
      const response = await instance.put(
        `${constants.API_BASE_URL}/api/auth/roles/${id}`,
        { ...record }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async updatePermissionById(record) {
    // Get axios instance
    const instance = getAxios();
    try {
      const id = record.id;
      delete record.id;
      // Call the API
      const response = await instance.put(
        `${constants.API_BASE_URL}/api/auth/permissions/${id}`,
        { ...record }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout(); 
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async addRolePermission(roleId, permissionId) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/auth/role-permissions`,
        {
          roleid: roleId,
          permissionid: permissionId,
        }
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },
  async removeRolePermission(roleId, permissionId) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.delete(
        `${constants.API_BASE_URL}/api/auth/role-permissions/${roleId}/${permissionId}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }

      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error.response);
    }
    return null;
  },

};

export default authApi;
